import React, { useState } from 'react';
import { useWindowSize } from '@src/utils/utils';
import { useHistory, useLocation } from 'react-router-dom';
import { LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { QueryClient, useQueryClient } from '@tanstack/react-query';
import { Menu, Button, Drawer } from 'antd';
import { logout } from '../../services/Admin';
import './index.less';

const items = [
  {
    key: 'approvals',
    name: '🗂️ Approvals',
  },
  {
    key: 'domains',
    name: '🕸️ Domains',
  },
  {
    key: 'users',
    name: '👤 Users',
  },
  {
    key: 'requests',
    name: '🔗 Requests',
  },
  {
    key: 'announcements',
    name: '📢 Announcements',
  },
  {
    key: 'stats',
    name: '📊 Stats',
  },
];

function AppBar() {
  const location = useLocation();
  const history = useHistory();
  const queryClient = useQueryClient();
  const size = useWindowSize();
  const mobile = size.width < 850;
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onClickLogout = () => {
    logout();
    localStorage.removeItem('sessionId');
    QueryClient.clear();
    history.push('/auth');
  };

  const onClick = () => {
    logout();
    localStorage.removeItem('sessionId');
    queryClient.clear();
    history.push('/auth');
  };

  return (
    <div id="AppBar">
      <img src="/logo.png" alt="karmalinks logo" width={45} />
      {mobile ? (
        <>
          <div className="Fill" />
          <Button type="secondary" onClick={showDrawer} className="menuIcon">
            <MenuOutlined />
          </Button>
        </>
      ) : (
        <>
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname.split('/')[1]]}
          >
            {items.map((item) => (
              <Menu.Item style={item.key === 'stats' ? { background: 'rgba(0,0,0,0.03)' } : {}} key={item.key}>
                <a href={`#/${item.key}`}>
                  <span className="Hide_mobile">{item.name}</span>
                </a>
              </Menu.Item>
            ))}
          </Menu>
          <Button icon={<LogoutOutlined />} onClick={onClick}>
            <span className="Hide_mobile">Log out</span>
          </Button>
        </>
      )}
      <Drawer
        title="Menu"
        placement="top"
        onClose={onClose}
        visible={open}
        width="100%"
        height="80%"
        className="drawerMobile"
      >
        <div className="innerDrawer">
          <div className="mobileMenuInline">
            <Menu mode="inline" className="Mobile_menu">
              {items.map((item) => (
                <Menu.Item style={item.key === 'stats' ? { background: 'rgba(0,0,0,0.03)' } : {}} key={item.key}>
                  <a href={`#/${item.key}`}>{item.name}</a>
                </Menu.Item>
              ))}
            </Menu>
          </div>
          <div className="bottomDrawer">
            <div className="bottomInner">
              <Button icon={<LogoutOutlined />} onClick={onClickLogout}>
                Log out
              </Button>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default AppBar;
